import * as React from 'react'

export const Fire = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      {...props}
      width="100%"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 4042 5196"
      fill="none"
    >
      <g>
        <mask id="grayscale-mask" className="fill-white">
          <g className="animate-raise">
            <path
              className="animate-waves"
              d="M-6377 1597.29V2296.81C-5780.36 2296.81 -5476.15 2448.93 -5182.89 2596.91C-4888.78 2744.88 -4584.56 2897 -3985.4 2897C-3387.08 2897 -3082.02 2743.85 -2787.91 2596.91C-2494.65 2449.97 -2190.44 2296.82 -1593.8 2296.82C-997.164 2296.82 -692.947 2448.93 -399.685 2596.91C-105.581 2744.88 198.636 2897 797.8 2897C1396.96 2897 1701.18 2743.85 1995.29 2596.91C2288.55 2449.97 2592.76 2296.82 3189.4 2296.82C3786.04 2296.82 4090.25 2448.93 4383.51 2596.91C4677.62 2744.88 4981.84 2897 5581 2897V-3645H-6377V1597.29Z"
            />
          </g>
        </mask>
        <mask id="color-mask" className="fill-white">
          <g className="animate-raise">
            <path
              className="animate-waves"
              d="M5581 3576.71V2877.18C4984.36 2877.18 4680.15 2725.07 4386.89 2577.09C4092.78 2429.12 3788.56 2277 3189.4 2277C2591.08 2277 2286.02 2430.15 1991.91 2577.09C1698.65 2724.03 1394.44 2877.18 797.8 2877.18C201.164 2877.18 -103.053 2725.07 -396.315 2577.09C-690.419 2429.12 -994.636 2277 -1593.8 2277C-2192.96 2277 -2497.18 2430.15 -2791.29 2577.09C-3084.55 2724.03 -3388.76 2877.18 -3985.4 2877.18C-4582.04 2877.18 -4886.25 2725.07 -5179.51 2577.09C-5473.62 2429.12 -5777.84 2277 -6377 2277V8819H5581V3576.71Z"
            />
          </g>
        </mask>
        <g mask="url(#grayscale-mask)">
          <g>
            <path d="M1024.5 1109L943 1636L1262 1402.5L1024.5 1109Z M3431 2007.5L1706 4113.5L2679 3980.5L3431 2007.5Z M2747 1271L2339 1057L2890 897.5L2747 1271Z M524 4665L2107.5 5195.5L274 2400L0 3789L524 4665Z M1440 1524.5L2529.5 2636L2615 1472L1548 753.5L1440 1524.5Z" />
          </g>
          <g>
            <path d="M2490 580L2733 4L2898.5 199.5L2490 580Z M274 2400L2528.5 2635L1440 1524.5L274 2400Z M2067 1103L1548 753.5L2377 312L2067 1103Z" />
          </g>
          <g>
            <path d="M3450.5 4745L2490 5091.5L4038 3889.5L3450.5 4745Z M3709.5 2852L2236.5 5141.5L3431 2007.5L3709.5 2852Z" />
          </g>
          <g>
            <path d="M3807 3183.5L2490 5091.5L4038 3889.5L3807 3183.5Z M1705 4114L2236.5 5141.5L2679 3980.5L1705 4114Z M1401.5 4119.5L1057 3594L2530 2635.5L1401.5 4119.5Z" />
          </g>
          <g>
            <path d="M2899 1439.5L2701 2898.5L3431 2007.5L2899 1439.5Z M1057 3594L274 2400L2530 2635.5L1057 3594Z" />
          </g>
        </g>

        <g mask="url(#color-mask)">
          <g className="duration-500 ease-in-out fill-fire1">
            <path d="M1024.5 1109L943 1636L1262 1402.5L1024.5 1109Z M3431 2007.5L1706 4113.5L2679 3980.5L3431 2007.5Z M2747 1271L2339 1057L2890 897.5L2747 1271Z M524 4665L2107.5 5195.5L274 2400L0 3789L524 4665Z M1440 1524.5L2529.5 2636L2615 1472L1548 753.5L1440 1524.5Z" />
          </g>
          <g className="duration-500 ease-in-out fill-fire2">
            <path d="M2490 580L2733 4L2898.5 199.5L2490 580Z M274 2400L2528.5 2635L1440 1524.5L274 2400Z M2067 1103L1548 753.5L2377 312L2067 1103Z" />
          </g>
          <g className="duration-500 ease-in-out fill-fire3">
            <path d="M3450.5 4745L2490 5091.5L4038 3889.5L3450.5 4745Z M3709.5 2852L2236.5 5141.5L3431 2007.5L3709.5 2852Z" />
          </g>
          <g className="duration-500 ease-in-out fill-fire4">
            <path d="M3807 3183.5L2490 5091.5L4038 3889.5L3807 3183.5Z M1705 4114L2236.5 5141.5L2679 3980.5L1705 4114Z M1401.5 4119.5L1057 3594L2530 2635.5L1401.5 4119.5Z" />
          </g>
          <g className="duration-500 ease-in-out fill-fire5">
            <path d="M2899 1439.5L2701 2898.5L3431 2007.5L2899 1439.5Z M1057 3594L274 2400L2530 2635.5L1057 3594Z" />
          </g>
        </g>
      </g>
      <g>
        <mask id="outline-mask" className="fill-white">
          <g className="animate-raise-outline">
            <path
              className="animate-waves-outline"
              d="M5581 3576.71V2877.18C4984.36 2877.18 4680.15 2725.07 4386.89 2577.09C4092.78 2429.12 3788.56 2277 3189.4 2277C2591.08 2277 2286.02 2430.15 1991.91 2577.09C1698.65 2724.03 1394.44 2877.18 797.8 2877.18C201.164 2877.18 -103.053 2725.07 -396.315 2577.09C-690.419 2429.12 -994.636 2277 -1593.8 2277C-2192.96 2277 -2497.18 2430.15 -2791.29 2577.09C-3084.55 2724.03 -3388.76 2877.18 -3985.4 2877.18C-4582.04 2877.18 -4886.25 2725.07 -5179.51 2577.09C-5473.62 2429.12 -5777.84 2277 -6377 2277V8819H5581V3576.71Z"
            />
          </g>
        </mask>
        <g mask="url(#outline-mask)">
          <path
            className="stroke-svgoutline fill-transparent"
            d="M2492 5090L3452.5 4743.5L4040 3888Z L3452.5 4743.5 M2492 5090L4040 3888L3809 3182L2492 5090Z M2238.5 5140L1707 4112.5L2681 3979L2238.5 5140Z M2238.5 5140L2238.5 5140L3433 2006L3711.5 2850.5Z M3433 2006L1708 4112L2681 3979L3433 2006Z
           M2703 2897L3433 2006L2901 1438L2703 2897Z M276 2398.5L2 3787.5L526 4663.5L2109.5 5194Z
           M1059 3592.5L1403.5 4118L2532 2634L1059 3592.5Z M1059 3592.5L276 2398.5L2532 2634L1059 3592.5Z
           M276 2398.5L2530.5 2633.5L1442 1523L276 2398.5Z M2531.5 2634.5L1442 1523L1550 752L2617 1470.5L2531.5 2634.5Z
           M2069 1101.5L1550 752L2379 310.5L2069 1101.5Z M945 1634.5L1264 1401L1026.5 1107.5L945 1634.5Z
           M2749 1269.5L2892 896L2341 1055.5Z M2492 578.5L2900.5 198L2735 2.5L2492 578.5Z"
            fill="url(#animation1)"
            pathLength="1"
            strokeWidth={25}
          />
        </g>
      </g>
    </svg>
  )
}
